export default {"src":"/login-app/[GIT_HASH]/_next/static/media/collapse.03e327af.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};